import { render, staticRenderFns } from "./personalLayout.vue?vue&type=template&id=aae6f870&scoped=true&"
import script from "./personalLayout.vue?vue&type=script&lang=js&"
export * from "./personalLayout.vue?vue&type=script&lang=js&"
import style0 from "./personalLayout.vue?vue&type=style&index=0&id=aae6f870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae6f870",
  null
  
)

export default component.exports